'use client';

import { useLayoutEffect, useState } from 'react';
import { getValueFromCookie } from '@benzinga/utils';

import {
  applyPortfolioShellDocumentAttributes,
  clearPortfolioShellDocumentAttributes,
  isLoggedInFromAccessType,
  markPortfolioShellReady,
} from './portfolioShellBoot';

export type PortfolioPageShell = 'marketing' | 'workspace';

export { isLoggedInFromAccessType };

export const readAccessTypeLoggedIn = (): boolean => isLoggedInFromAccessType(getValueFromCookie('bz_access_type'));

export const getPortfolioPageShell = (sessionLoggedIn: boolean, cookieLoggedIn: boolean): PortfolioPageShell =>
  sessionLoggedIn || cookieLoggedIn ? 'workspace' : 'marketing';

export const shouldShowHoldingsSlot = (
  isLoadingWatchlists: boolean,
  hasHoldings: boolean,
  snapshotHasHoldings: boolean,
): boolean => (isLoadingWatchlists ? snapshotHasHoldings : hasHoldings);

export const shouldShowHeaderAllocationSkeleton = (
  isLoadingWatchlists: boolean,
  hasHoldings: boolean,
  isLoadingPrices: boolean,
  isLoadingSectors: boolean,
  allocationCount: number,
): boolean =>
  hasHoldings && allocationCount === 0 && (isLoadingWatchlists || isLoadingPrices || isLoadingSectors);

export const usePortfolioShellTakeover = (): { cookieLoggedIn: boolean; mounted: boolean } => {
  const [mounted, setMounted] = useState(false);
  const [cookieLoggedIn, setCookieLoggedIn] = useState(false);

  useLayoutEffect(() => {
    applyPortfolioShellDocumentAttributes();
    setCookieLoggedIn(readAccessTypeLoggedIn());
    setMounted(true);
    return clearPortfolioShellDocumentAttributes;
  }, []);

  useLayoutEffect(() => {
    if (!mounted) {
      return;
    }
    markPortfolioShellReady();
  }, [mounted]);

  return { cookieLoggedIn, mounted };
};
